<main class="container-fluid py-6x">
  <div class="d-flex justify-content-between align-items-center">
    <h1 class="title-lg mb-4x">Vehicles On Auction</h1>
    <button
      ds-button
      appearance="primary"
      (click)="openWatchlistModal()"
    >
      <ds-icon icon="add" inline></ds-icon>&nbsp;Add Vehicle to Watchlist
    </button>
  </div>

  <ds-box>
    <ds-box-content class="w-100">
      <ds-tabs>
        <ds-tabs-label for="auction" (click)="onAuctionTabClick()">
          Vehicles On Auction
        </ds-tabs-label>
        <ds-tabs-content id="auction">
          <ng-container *ngIf="searchClicked;">
            <ng-container *ngIf="vehicles && vehicles.length > 0; else noAuctionVehicles ">
              <div class="row mt-4">
                <div class="col-sm-12">
                  <ds-box [detachFooter]="true" class="h-100">
                    <ds-box-content>
                      <div class="table-section">
                        <div class="table-scroll-container">
                          <table class="zebra-table fixed-header-table">
                            <thead>
                            <tr class="table_head">
                              <th>VIN</th>
                              <th>Brand</th>
                              <th>Description</th>
                              <th>Model Year</th>
                              <th>Location</th>
                              <th>Remaining Time</th>
                              <th>Reserve Price</th>
                              <th>Recon Price</th>
                              <th>Current Bid</th>
                              <th>Photographs</th>
                              <th>Condition Report</th>
                              <th>Quick Bid</th>
                              <th></th>
                              <th></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngFor="let vehicle of vehicles" >
                              <td>
                                <div class="brand-cell">
                                  <span class="brand-name"><a
                                    href="javascript:void(0)"
                                    role="button"
                                    tabindex="0"
                                    (click)="openOverviewModal(vehicle)"
                                    (keydown.enter)="openOverviewModal(vehicle)"
                                    (keydown.space)="openOverviewModal(vehicle); $event.preventDefault()"
                                    class="vehicle-link"
                                    title="View Vehicle Overview"
                                  >{{ vehicle.id.toUpperCase() }}</a></span>
                                </div>
                              </td>
                              <td>
                                <div class="brand-cell">
                                  <span class="brand-name">{{ vehicle.brand }}</span>
                                </div>
                              </td>
                              <td>
                                <span class="vehicle-description">{{ vehicle.description }}</span>
                              </td>
                              <td class="text-center">{{ vehicle.modelYear }}</td>
                              <td>{{ vehicle.loadedDealerName }}</td>
                              <td>
                                <span class="remaining-time"
                                      [class.urgent]="vehicle.remainingTimeMs <= 30 * 60 * 1000"
                                      [class.critical]="vehicle.remainingTimeMs <= 15 * 60 * 1000">
                                  <strong>{{ vehicle.remainingTimeDisplay }}</strong>
                                </span>
                              </td>
                              <td class="text-end">
                                <span class="price">{{ formatCurrency(vehicle.reservePrice) }}</span>
                              </td>
                              <td class="text-end">
                                <span class="price recon-price">{{ formatCurrency(vehicle.reconPrice) }}</span>
                              </td>
                              <td class="text-end">
                                <span class="price current-bid">{{ formatCurrency(vehicle.currentBid > vehicle.highestBid ? vehicle.currentBid : vehicle.highestBid) }}</span>
                              </td>
                              <td class="text-center">
                               <span>
                                 <ds-icon
                                   *ngIf="vehicle.photographsList || vehicle.photographS3Keys"
                                   icon="camera"
                                   size="lg"
                                   tone="action"
                                   title="Photographs available"
                                    (click)="openPhotographsModal(vehicle)"
                                 ></ds-icon>
                               </span>
                              </td>
                              <td class="text-center" >
                                <span *ngIf="vehicle.conditionReportList || vehicle.conditionReportS3Key">
                                  <ds-icon
                                    icon="download"
                                    title="Condition report available"
                                    class="action-icon"
                                    size="lg"
                                    tone="action"
                                    (click)="onViewConditionReportPurch({vin: vehicle.id, brand: vehicle.brand, description: vehicle.description, model: vehicle.description, year: vehicle.modelYear, sellingDealer: '', purchasePrice: vehicle.reservePrice, guid: '', conditionReportS3Key: vehicle.conditionReportS3Key, conditionReportList: vehicle.conditionReportList, status: 'ACTIVE'})"
                                    style="cursor:pointer; margin-right: 8px;"
                                  ></ds-icon>

                                </span>

                              </td>
                              <td>
                                {{ quickBidMap[vehicle.id] || 0 }}
                              </td>
                              <td class="text-center">
                                <span style="display: inline-flex; align-items: center;">
                                  <ds-icon icon="add" size="md" title="Place Quick Bid" class="action-icon" tone="positive"
                                           (click)="addQuickBid(vehicle)" [disabled]="!canBid" style="cursor:pointer;"></ds-icon>
                                  <ds-icon icon="subtract" size="md" title="Subtract Quick Bid" style="margin-right: 5px" class="action-icon" tone="caution"
                                           (click)="subtractQuickBid(vehicle)" [disabled]="!canBid" style="cursor:pointer;"></ds-icon>
                                  <ds-icon
                                    icon="check"
                                    class="action-icon" tone="positive"
                                    size="md"
                                    title="Place Quick Bid"
                                    [disabled]="!canBid"
                                    (click)="placeBid(vehicle, quickBidMap[vehicle.id])"
                                  ></ds-icon>
                                </span>
                              </td>
                              <td>
                                <ds-button
                                  ds-button
                                  size="md"
                                  (click)="openPlacebidModal(vehicle)"
                                  title="open place bid modal"
                                  variant="outline"
                                  [disabled]="!canBid"
                                >Place Bid</ds-button>
                              </td>
                            </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </ds-box-content>
                  </ds-box>
                </div>
              </div>
            </ng-container>

          </ng-container>

        </ds-tabs-content>

        <!-- Tab 2: Auction Completed Vehicles -->
        <!--  <ds-tabs-label for="completed" (click)="onCompletedTabClick()"> -->
        <ds-tabs-label for="completed" (click)="onCompletedTabClick()">
          Auction Completed Vehicles
        </ds-tabs-label>
        <ds-tabs-content id="completed">
          <div class="tab-content">

            <div class="row">
              <div class="col-sm-12">
                <ng-container >
                  <!-- Accordion 1: Match or Accept Highest Bid -->
                  <ds-box class="mb-4 accordion-box">
                    <ds-box-header class="accordion-header">
                      <button
                        class="accordion-button"
                        (click)="toggleMatchBidAccordion()"
                        [attr.aria-expanded]="isMatchBidExpanded">
                        <h3 class="section-title mb-0">Match or Accept Highest Bid</h3>
                        <ds-icon [icon]="isMatchBidExpanded ? 'expand_less' : 'expand_more'"></ds-icon>
                      </button>
                    </ds-box-header>
                    <ds-box-content *ngIf="isMatchBidExpanded" class="accordion-content">
                      <div class="table-section">
                        <div class="table-scroll-container" *ngIf="completedVehicles && completedVehicles.length > 0; else noAuctionCompletedVehicles">
                          <table class="zebra-table fixed-header-table">
                            <thead>
                            <tr class="table_head">
                              <th>VIN</th>
                              <th>Brand</th>
                              <th>Description</th>
                              <th>Year</th>
                              <th>Purchasing Dealer</th>
                              <th>Purchase Price</th>
                              <th>Match Bid</th>
                              <th>Expiry Date</th>
                              <th></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngFor="let vehicle of completedVehicles">
                              <td><div class="brand-cell">
                                  <span class="brand-name"><a
                                    (click)="openOverviewModalforCompletedVehicle(vehicle)"
                                    class="vehicle-link"
                                    title="View Vehicle Overview"
                                  >{{ vehicle.vin.toUpperCase() }}</a></span>
                              </div></td>
                              <td>{{ vehicle.brand }}</td>
                              <td>{{ vehicle.description }}</td>
                              <td class="text-center">{{ vehicle.year }}</td>
                              <td>{{ vehicle.purchasingDealerName }}</td>
                              <td class="text-end">{{ formatCurrency(vehicle.purchasePrice) }}</td>
                              <td class="text-end">{{ formatCurrency(vehicle.matchBid) }}</td>
                              <td>{{ vehicle.expiryDate }}</td>
                              <td class="text-center">
                                <ds-icon
                                  icon="file_copy"
                                  title="Copy Unique ID to Clipboard"
                                  class="action-icon"
                                  size="lg"
                                  tone="action"
                                  (click)="onCopyUniqueId(vehicle)"
                                  style="cursor:pointer; margin-right: 8px;"
                                ></ds-icon>
                                <ds-icon
                                  icon="download"
                                  title="View Condition Report"
                                  class="action-icon"
                                  size="lg"
                                  tone="action"
                                  (click)="onViewConditionReportPurch({vin: vehicle.vin, brand: vehicle.brand, description: vehicle.description, model: vehicle.description, year: vehicle.year, sellingDealer: '', purchasePrice: vehicle.purchasePrice, guid: '', conditionReportS3Key: vehicle.conditionReportS3Key, conditionReportList: vehicle.conditionReportList, status: 'ACTIVE'})"
                                  style="cursor:pointer; margin-right: 8px;"
                                ></ds-icon>
                                <ds-icon
                                  icon="hand_coin"
                                  size="lg"
                                  title="Match Highest Bid"
                                  class="action-icon"
                                  tone="positive"
                                  [disabled]="!canBid"
                                  (click)="onMatchHighestBid(vehicle)"
                                  style="cursor:pointer; margin-right: 8px;"
                                ></ds-icon>
                                <ds-icon
                                  icon="check_double"
                                  title="Accept Highest Bid"
                                  class="action-icon"
                                  size="lg"
                                  tone="positive"
                                  [disabled]="!canBid"
                                  (click)="onAcceptHighestBid(vehicle)"
                                  style="cursor:pointer;"
                                ></ds-icon>
                              </td>
                            </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </ds-box-content>
                  </ds-box>
                </ng-container>
                <!-- Accordion 2: Awaiting 'Order placed' status on DSP -->
                <ng-container >
                  <ds-box class="mb-4 accordion-box">
                    <ds-box-header class="accordion-header">
                      <button
                        class="accordion-button"
                        (click)="toggleAwaitingOrderAccordion()"
                        [attr.aria-expanded]="isAwaitingOrderExpanded">
                        <h3 class="section-title mb-0">Awaiting 'Order placed' status on DSP</h3>
                        <ds-icon [icon]="isAwaitingOrderExpanded ? 'expand_less' : 'expand_more'"></ds-icon>
                      </button>
                    </ds-box-header>
                    <ds-box-content *ngIf="isAwaitingOrderExpanded" class="accordion-content">
                      <div class="table-section">
                        <div class="table-scroll-container">
                          <table class="zebra-table fixed-header-table"  *ngIf="awaitingVehicles && awaitingVehicles.length > 0; else noAuctionCompletedVehicles">
                            <thead>
                            <tr class="table_head">
                              <th>VIN</th>
                              <th>Brand</th>
                              <th>Description</th>
                              <th>Year</th>
                              <th>Purchasing Dealer</th>
                              <th>Purchase Price</th>
                              <th></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngFor="let vehicle of awaitingVehicles">
                              <td><div class="brand-cell">
                                  <span class="brand-name"><a
                                    (click)="openOverviewModalforCompletedVehicle(vehicle)"
                                    class="vehicle-link"
                                    title="View Vehicle Overview"
                                  >{{ vehicle.vin.toUpperCase() }}</a></span>
                              </div></td>
                              <td>{{ vehicle.brand }}</td>
                              <td>{{ vehicle.description }}</td>
                              <td class="text-center">{{ vehicle.year }}</td>
                              <td>{{ vehicle.purchasingDealerName }}</td>
                              <td class="text-end">{{ formatCurrency(vehicle.purchasePrice) }}</td>
                              <td class="text-center">
                                <ds-icon
                                  icon="file_copy"
                                  title="Copy Unique ID to Clipboard"
                                  class="action-icon"
                                  size="lg"
                                  tone="action"
                                  (click)="onCopyUniqueId(vehicle)"
                                  style="cursor:pointer; margin-right: 8px;"
                                ></ds-icon>
                                <ds-icon
                                  icon="download"
                                  title="View Condition Report"
                                  class="action-icon"
                                  size="lg"
                                  tone="action"
                                  (click)="onViewConditionReport(vehicle)"
                                  style="cursor:pointer; margin-right: 8px;"
                                ></ds-icon>
                                <span *ngIf="isConcludable(vehicle)">
                                <ds-icon
                                  icon="quality"
                                  size="lg"
                                  title="Conclude deal"
                                  class="action-icon"
                                  tone="positive"
                                  [disabled]="!canBid"
                                  (click)="OnConcludeBid(vehicle)"
                                  style="cursor:pointer; margin-right: 8px;"
                                ></ds-icon>
                                  </span>
                                <span *ngIf="isPushToHighBid(vehicle)">
                                <ds-icon
                                  icon="hand_heart"
                                  size="lg"
                                  title="Push to highest bidder"
                                  class="action-icon"
                                  tone="positive"
                                  [disabled]="!canBid"
                                  (click)="OnConcludeBid(vehicle)"
                                  style="cursor:pointer; margin-right: 8px;"
                                ></ds-icon>
                                  </span>
                                <ds-icon
                                  icon="close"
                                  title="Cancel Deal"
                                  class="action-icon"
                                  tone="critical"
                                  size="lg"
                                  [disabled]="!canBid"
                                  (click)="onCancelDeal(vehicle)"
                                  style="cursor:pointer;"
                                ></ds-icon>
                              </td>
                            </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </ds-box-content>
                  </ds-box>
                </ng-container>
              </div>
            </div>
          </div>
        </ds-tabs-content>

        <!-- Tab 3: Purchasing Vehicles -->
        <ds-tabs-label for="purchasing" (click)="onPurchasingTabClick()">
          Purchasing Vehicles
        </ds-tabs-label>
        <ds-tabs-content id="purchasing">
          <div class="tab-content">
            <!--    <ng-container *ngIf="purchasingVehicles && purchasingVehicles.length > 0; else noVehicles"> -->
            <ng-container *ngIf="purchasingVehicles && purchasingVehicles.length > 0; else noAuctionPurchasingVehicles">
              <div class="row mt-4">
                <div class="col-sm-12">
                  <ds-box [detachFooter]="true" class="h-100">
                    <ds-box-content>
                      <div class="table-section">
                        <div class="table-scroll-container">
                          <table class="zebra-table fixed-header-table">
                            <thead>
                            <tr class="table_head">
                              <th>VIN</th>
                              <th>Brand</th>
                              <th>Description</th>
                              <th>Model</th>
                              <th>Year</th>
                              <th>Selling Dealer</th>
                              <th>Purchase Price</th>
                              <th>Status</th>
                              <th>Condition Report</th>
<!--                              <th></th>-->
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngFor="let vehicle of purchasingVehicles">
                              <td><div class="brand-cell">
                                  <span class="brand-name"><a
                                    (click)="openOverviewModalForPurchasingVehicle(vehicle)"
                                    (keydown.enter)="openOverviewModalForPurchasingVehicle(vehicle)"
                                    (keydown.space)="openOverviewModalForPurchasingVehicle(vehicle); $event.preventDefault()"
                                    class="vehicle-link"
                                    title="View Vehicle Overview"
                                  >{{ vehicle.vin.toUpperCase() }}</a></span>
                              </div></td>
                              <td>{{ vehicle.brand }}</td>
                              <td>{{ vehicle.description }}</td>
                              <td>{{ vehicle.model }}</td>
                              <td class="text-center">{{ vehicle.year }}</td>
                              <td>{{ vehicle.sellingDealer }}</td>
                              <td class="text-end">{{ formatCurrency(vehicle.purchasePrice) }}</td>
                              <td>{{ vehicle.status }}</td>
                              <td>
                                <ds-icon
                                  icon="download"
                                  title="View Condition Report"
                                  class="action-icon"
                                  size="lg"
                                  tone="action"
                                  (click)="onViewConditionReportPurch(vehicle)"
                                  style="cursor:pointer; margin-right: 8px;"
                                ></ds-icon>
                              </td>
<!--                              <td>-->
<!--                                <span *ngIf="vehicle.statusCode === 'OC'" class="actionbutton">-->
<!--                                <ds-icon type="button"-->
<!--                                        title="Request Financial Services Floorplan"-->
<!--                                        class="action sold"-->
<!--                                        (click)="addToSFFloorplan(vehicle, $event)"-->
<!--                                        [disabled]="!canBid"-->
<!--                                        style="opacity:1;"-->
<!--                                ></ds-icon>-->
<!--                                <ds-icon type="button"-->
<!--                                        title="Deal Concluded"-->
<!--                                        class="action delete"-->
<!--                                        (click)="doSellingAction('H', vehicle, $event)"-->
<!--                                        [disabled]="!canBid"-->
<!--                                        style="opacity:1;"-->
<!--                                ></ds-icon>-->
<!--                                </span>-->
<!--                              </td>-->
                            </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </ds-box-content>
                  </ds-box>
                </div>
              </div>
            </ng-container>
          </div>
        </ds-tabs-content>

        <!-- Tab 4: Vehicle Watch List -->
        <ds-tabs-label for="watchlist" (click)="onWatchlistTabClick()">
          Vehicle Watch List
        </ds-tabs-label>
        <ds-tabs-content id="watchlist">
          <div class="tab-content">
            <!--  <ng-container *ngIf="watchlistVehicles && watchlistVehicles.length > 0; else noVehicles">  -->
            <ng-container *ngIf="watchlistVehicles && watchlistVehicles.length > 0; else noWatchlistVehicles">
              <div class="row mt-4">
                <div class="col-sm-12">
                  <ds-box [detachFooter]="true" class="h-100">
                    <ds-box-content>
                      <div class="table-section">
                        <div class="table-scroll-container">
                          <table class="zebra-table fixed-header-table">
                            <thead>
                            <tr class="table_head">
                              <th>Brand</th>
                              <th>Model</th>
                              <th>ADG Code</th>
                              <th>Reserve Price</th>
                              <th>Recon Price</th>
                              <th>Mileage</th>
                              <th>Year</th>
                              <th></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngFor="let vehicle of watchlistVehicles">
                              <td>{{ vehicle.brand }}</td>
                              <td>{{ vehicle.model }}</td>
                              <td>{{ vehicle.adgCode }}</td>
                              <td class="text-end">{{ formatCurrency(vehicle.reservePrice) }}</td>
                              <td class="text-end">{{ formatCurrency(vehicle.reconPrice) }}</td>
                              <td class="text-end">{{ vehicle.mileage.toLocaleString() }} km</td>
                              <td class="text-center">{{ vehicle.year }}</td>
                              <td class="text-center">
                                <ds-icon
                                  icon="close"
                                  title="Remove From Watchlist"
                                  class="action-icon"
                                  tone="critical"
                                  size="lg"
                                  (click)="onDeleteFromWatchList(vehicle)"
                                  style="cursor:pointer;"
                                ></ds-icon>
                              </td>
                            </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </ds-box-content>
                  </ds-box>
                </div>
              </div>
            </ng-container>
            <ng-template #noWatchlistVehicles>
              <ds-empty-state
                heading="No Vehicles in Your Watchlist"
                description="You have not added any vehicles to your watchlist yet."
                footnote="Please use the 'Add Vehicle to Watchlist' button to start tracking vehicles you're interested in."
                illustration="create"
                size="lg"
              >
              </ds-empty-state>
            </ng-template>

          </div>
        </ds-tabs-content>
      </ds-tabs>
    </ds-box-content>
  </ds-box>

  <ng-template #noAuctionVehicles>
    <ds-empty-state
      heading="No Vehicles On Auction"
      description="There are currently no vehicles available for auction."
      footnote="Please check back later or use the 'Add Vehicle to Watchlist' button to track vehicles you're interested in."
      illustration="create"
      size="lg"
    >
    </ds-empty-state>
  </ng-template>


  <ng-template #noAuctionCompletedVehicles>
    <ds-empty-state
      heading="No Auction Completed Vehicles"
      description="There are currently no completed vehicles in the auction."
      footnote="Please check back later."
      illustration="create"
      size="sm"
    >
    </ds-empty-state>
  </ng-template>

  <ng-template #noAuctionPurchasingVehicles>
    <ds-empty-state
      -empty-state
      heading="No Purchasing Vehicles"
      description="There are currently no vehicles available for purchasing."
      illustration="create"
      size="lg"
    >
    </ds-empty-state>
  </ng-template>

  <ds-modal
    #watchlistModal
    [ds-modal-trigger-for]="watchlistModal"
    [(isModalOpen)]="watchlistModalIsOpen"
    [dimensionsConfig]="{ width: '1000px', height: 'auto' }"
    [detachFooter]="true"
  >
    <ds-box-header style="font-size: xx-large; font-weight: bold">
      <h1>Add Vehicle to Watchlist</h1>
    </ds-box-header>
    <ds-box-content>
      <div class="watchlist-form">
        <div class="row gx-3">
          <div class="col-md-6 mb-3">
            <ds-form-field>
              <label ds-label class="form-label" for="vehicleTypeSelect">Vehicle Type *</label>
              <ds-select
                id="vehicleTypeSelect"
                [options]="vehicleTypes"
                [(value)]="watchlistForm.vehicleType"
                [labellingConfig]="{ placeholder: 'Please Select a Vehicle Type' }"
                (valueChange)="onVehicleTypeChange(watchlistForm.vehicleType)"
                required
              ></ds-select>
            </ds-form-field>
          </div>

          <div class="col-md-6 mb-3">
            <ds-form-field>
              <label ds-label class="form-label" for="modelYearSelect">Model Year *</label>
              <ds-select
                id="modelYearSelect"
                [options]="modelYearOptions"
                [(value)]="watchlistForm.modelYear"
                [labellingConfig]="{ placeholder: 'Please Select a Year' }"
                [disabled]="!watchlistForm.vehicleType"
                (valueChange)="onModelYearChange(watchlistForm.vehicleType, watchlistForm.modelYear)"
                required
              ></ds-select>
            </ds-form-field>
          </div>

          <div class="col-md-6 mb-3">
            <ds-form-field>
              <label ds-label class="form-label" for="brandSelect">Brand *</label>
              <ds-select
                id="brandSelect"
                [options]="brandOptions"
                [(value)]="watchlistForm.brand"
                [labellingConfig]="{ placeholder: 'Please Select a Brand' }"
                [disabled]="!watchlistForm.modelYear"
                (valueChange)="onBrandChange(watchlistForm.vehicleType, watchlistForm.modelYear, watchlistForm.brand)"
                required
              ></ds-select>
            </ds-form-field>
          </div>

          <div class="col-md-6 mb-3">
            <ds-form-field>
              <label ds-label class="form-label" for="modelSelect">Model *</label>
              <ds-select
                id="modelSelect"
                [options]="modelOptions"
                [(value)]="watchlistForm.model"
                [labellingConfig]="{ placeholder: 'Please Select a Model' }"
                [disabled]="!watchlistForm.brand"
                (valueChange)="onModelChange(watchlistForm.vehicleType, watchlistForm.modelYear, watchlistForm.brand, watchlistForm.model)"
                required
              ></ds-select>
            </ds-form-field>
          </div>

          <div class="col-md-6 mb-3">
            <ds-form-field>
              <label ds-label class="form-label" for="fuelTypeSelect">Fuel Type *</label>
              <ds-select
                id="fuelTypeSelect"
                [options]="fuelTypeOptions"
                [(value)]="watchlistForm.fuelType"
                [labellingConfig]="{ placeholder: 'Please Select Fuel' }"
                [disabled]="!watchlistForm.model"
                (valueChange)="onFuelTypeChange(watchlistForm.vehicleType, watchlistForm.modelYear, watchlistForm.brand, watchlistForm.model, watchlistForm.fuelType)"
                required
              ></ds-select>
            </ds-form-field>
          </div>

          <div class="col-md-6 mb-3">
            <ds-form-field>
              <label ds-label class="form-label" for="transmissionTypeSelect">Transmission Type *</label>
              <ds-select
                id="transmissionTypeSelect"
                [options]="transmissionTypeOptions"
                [(value)]="watchlistForm.transmissionType"
                [labellingConfig]="{ placeholder: 'Please Select Transmission' }"
                [disabled]="!watchlistForm.fuelType"
                (valueChange)="onTransmissionTypeChange(watchlistForm.vehicleType, watchlistForm.modelYear, watchlistForm.brand, watchlistForm.model, watchlistForm.fuelType, watchlistForm.transmissionType)"
                required
              ></ds-select>
            </ds-form-field>
          </div>

          <div class="col-md-6 mb-3">
            <ds-form-field>
              <label ds-label class="form-label" for="variantSelect">Variant *</label>
              <ds-select
                id="variantSelect"
                [options]="variantOptions"
                [(value)]="watchlistForm.variant"
                (valueChange)="onVariantChange($event)"
                [labellingConfig]="{ placeholder: 'Please Select a Variant' }"
                [disabled]="!watchlistForm.transmissionType"
                required
              ></ds-select>
            </ds-form-field>
          </div>

          <div class="col-md-6 mb-3">
            <ds-form-field>
              <label ds-label class="form-label" for="adgCodeInput">ADG Code *</label>
              <input
                id="adgCodeInput"
                ds-input
                type="text"
                [(ngModel)]="watchlistForm.adgCode"
                placeholder="Enter ADG Code"
                [disabled]="!watchlistForm.variant"
                required
              />
            </ds-form-field>
          </div>

          <div class="col-md-6 mb-3">
            <ds-form-field>
              <label ds-label class="form-label" for="minReservePriceInput">Min Reserve Price *</label>
              <input
                id="minReservePriceInput"
                ds-input
                type="number"
                [(ngModel)]="watchlistForm.minReservePrice"
                placeholder="Enter Min Reserve Price"
                [disabled]="!watchlistForm.adgCode"
                required
              />
            </ds-form-field>
          </div>

          <div class="col-md-6 mb-3">
            <ds-form-field>
              <label ds-label class="form-label" for="maxReservePriceInput">Max Reserve Price *</label>
              <input
                id="maxReservePriceInput"
                ds-input
                type="number"
                [(ngModel)]="watchlistForm.maxReservePrice"
                placeholder="Enter Max Reserve Price"
                [disabled]="!watchlistForm.minReservePrice"
                required
              />
            </ds-form-field>
          </div>

          <div class="col-md-6 mb-3">
            <ds-form-field>
              <label ds-label class="form-label" for="minReconPriceInput">Min Recon Price *</label>
              <input
                id="minReconPriceInput"
                ds-input
                type="number"
                [(ngModel)]="watchlistForm.minReconPrice"
                placeholder="Enter Min Recon Price"
                [disabled]="!watchlistForm.maxReservePrice"
                required
              />
            </ds-form-field>
          </div>

          <div class="col-md-6 mb-3">
            <ds-form-field>
              <label ds-label class="form-label" for="maxReconPriceInput">Max Recon Price *</label>
              <input
                id="maxReconPriceInput"
                ds-input
                type="number"
                [(ngModel)]="watchlistForm.maxReconPrice"
                placeholder="Enter Max Recon Price"
                [disabled]="!watchlistForm.minReconPrice"
                required
              />
            </ds-form-field>
          </div>

          <div class="col-md-6 mb-3">
            <ds-form-field>
              <label ds-label class="form-label" for="minMileageInput">Min Mileage *</label>
              <input
                id="minMileageInput"
                ds-input
                type="number"
                [(ngModel)]="watchlistForm.minMileage"
                placeholder="Enter Min Mileage"
                [disabled]="!watchlistForm.maxReconPrice"
                required
              />
            </ds-form-field>
          </div>

          <div class="col-md-6 mb-3">
            <ds-form-field>
              <label ds-label class="form-label" for="maxMileageInput">Max Mileage *</label>
              <input
                id="maxMileageInput"
                ds-input
                type="number"
                [(ngModel)]="watchlistForm.maxMileage"
                placeholder="Enter Max Mileage"
                [disabled]="!watchlistForm.minMileage"
                required
              />
            </ds-form-field>
          </div>

          <div class="col-md-6 mb-3">
            <ds-form-field>
              <label ds-label class="form-label" for="minYearInput">Min Year *</label>
              <input
                id="minYearInput"
                ds-input
                type="number"
                [(ngModel)]="watchlistForm.minYear"
                placeholder="Enter Min Year"
                [disabled]="!watchlistForm.maxMileage"
                required
              />
            </ds-form-field>
          </div>

          <div class="col-md-6 mb-3">
            <ds-form-field>
              <label ds-label class="form-label" for="maxYearInput">Max Year *</label>
              <input
                id="maxYearInput"
                ds-input
                type="number"
                [(ngModel)]="watchlistForm.maxYear"
                placeholder="Enter Max Year"
                [disabled]="!watchlistForm.minYear"
                required
              />
            </ds-form-field>
          </div>
        </div>
      </div>
    </ds-box-content>
    <ds-box-footer>
      <ds-button variant="outline" style="margin-right: 5px" (click)="closeWatchlistModal()">
        Cancel
      </ds-button>
      <ds-button variant="primary" (click)="submitWatchlist()">
        Add to Watchlist
      </ds-button>
    </ds-box-footer>
  </ds-modal>

  <ds-modal
    #placeBidModal
    [ds-modal-trigger-for]="placeBidModal"
    [(isModalOpen)]="placeBidModalIsOpen"
    [dimensionsConfig]="{ width: '500px', height: 'auto' }"
    [detachFooter]="true">
    <ds-box-header>
      Place Your Bid
    </ds-box-header>
    <ds-box-content>
      <div class="row align-items-center">
        <div class="col-6 text-start">
          <div>Placing bid for vehicle ID:</div>
          <div>Reserve Price:</div>
          <div>Highest Current Bid:</div>
          <div>Your Bid Amount:</div>
          <div>Place a higher bid:</div>
        </div>
        <div class="col-6 text-end">
          <div>{{ BidModalVehicle.id }}</div>
          <div>{{ formatCurrency(BidModalVehicle.reservePrice) }}</div>
          <div>{{ formatCurrency(BidModalVehicle.highestBid) }}</div>
          <div>
            <ds-icon icon="subtract" class="action-icon" tone="caution" style="cursor:pointer; margin-right:5px;" (click)="decrementBidAmount(BidModalVehicle)"></ds-icon>
            {{ formatCurrency(modalBidAmount) }}
            <ds-icon icon="add" class="action-icon" tone="positive" style="cursor:pointer; margin-left:5px;" (click)="incrementBidAmount(BidModalVehicle)"></ds-icon>
          </div>
          <div>
            <input ds-input type="number" [(ngModel)]="modalBidAmount" min="0" style="width:215px; text-align:right;" />
          </div>
        </div>
      </div>
    </ds-box-content>
    <ds-box-footer>
      <ds-button
      variant="outline"
      style="margin-right: 5px"
      (click)="closePlaceBidModal()"
      >
        Cancel

      </ds-button>
      <ds-button
      variant="primary"
      [disabled]="!canBid"
      (click)="placeBid(BidModalVehicle, modalBidAmount)"

      >
        Place Bid
      </ds-button>
    </ds-box-footer>

  </ds-modal>

  <ds-modal
    #photographsModal
    [ds-modal-trigger-for]="photographsModal"
    [(isModalOpen)]="photographsModalIsOpen"
    [dimensionsConfig]="{ width: '625px', height: 'auto' }"
    [detachFooter]="true">
    <ds-box-header>
      Vehicle Photographs
    </ds-box-header>
    <ds-box-content>
      <div class="photographs-container">
        <div class="image-slider" tabindex="0" aria-roledescription="carousel" [attr.aria-label]="'Vehicle image gallery'">
          <img
            [src]="getPhotographImageUrl(photographsList[currentPhotoIndex])"
            alt="Vehicle Photograph"
            class="vehicle-image"
            style="width:600px; object-fit:contain;"
          />
          <button class="nav-btn prev" type="button"
                  (click)="currentPhotoIndex = (currentPhotoIndex > 0 ? currentPhotoIndex - 1 : photographsList.length - 1)"
                  aria-label="Previous image">‹</button>
          <span style="margin:0 10px; display:inline-block; width:100%; text-align:center;">{{ currentPhotoIndex + 1 }} / {{ photographsList.length }}</span>
          <button class="nav-btn next" type="button"
                  (click)="currentPhotoIndex = (currentPhotoIndex < photographsList.length - 1 ? currentPhotoIndex + 1 : 0)"
                  aria-label="Next image">›</button>
        </div>
        <ng-container *ngIf="!photographsList || photographsList.length === 0">
          <div class="no-photographs-message">
            <h2>No Photographs Available</h2>
          </div>
        </ng-container>
      </div>
    </ds-box-content>
  </ds-modal>

  <ds-modal
    #vehicleOverviewModal
    [ds-modal-trigger-for]="vehicleOverviewModal"
    [(isModalOpen)]="overviewModalIsOpen"
    [dimensionsConfig]="{ width: '400px', height: 'auto' }"
    [detachFooter]="true">
    <ds-box-header>
      Vehicle Overview
    </ds-box-header>
    <ds-box-content>
      <div class="vehicle-check-details">
        <div *ngFor="let item of [
          { label: 'Key Sets', value: initialVehicleCheckDetaisResponse.hasKeySets },
          { label: 'Tyre Thread', value: initialVehicleCheckDetaisResponse.hasTyreThread },
          { label: 'Full Service History', value: initialVehicleCheckDetaisResponse.hasFullServiceHistory },
          { label: 'Running Warranty', value: initialVehicleCheckDetaisResponse.hasRunningWarranty },
          { label: 'Motorplan', value: initialVehicleCheckDetaisResponse.hasMotorplan },
          { label: 'Registered in Customer\'s Name', value: initialVehicleCheckDetaisResponse.registeredInCustomersName },
          { label: 'Involved in Accident', value: initialVehicleCheckDetaisResponse.involvedInAccident },
          { label: 'CIA Comments', value: initialVehicleCheckDetaisResponse.ciaComments },
          { label: 'Photographs', value: 'yes' }
        ]" class="d-flex justify-content-between align-items-center mb-2">
          <span>{{ item.label }}</span>
          <span [ngClass]="item.label === 'Photographs' ? '' : (item.value ? 'text-success' : 'text-danger')">
            <ng-container *ngIf="item.label === 'Photographs'">
              <ds-icon
                *ngIf="item.value"
                icon="camera"
                size="lg"
                tone="action"
                title="Photographs available"
                (click)="openPhotographsModal(BidModalVehicle)"
                style="cursor:pointer;"
              ></ds-icon>
              <span *ngIf="!item.value" style="color:red;">No Photographs</span>
            </ng-container>
            <ng-container *ngIf="item.label !== 'Photographs'">
              <span *ngIf="item.value" style="color:green;">Yes</span>
              <span *ngIf="!item.value" style="color:red;">No</span>
            </ng-container>
          </span>
        </div>
      </div>
    </ds-box-content>
    <ds-box-footer>
      <ds-button
        variant="outline"
        style="margin-right: 5px"
        (click)="closeOverviewModal()"
        >Close</ds-button>
      <ds-button
        ds-button
        size="md"
        (click)="openPlacebidModal(BidModalVehicle)"
        title="open place bid modal"
        variant="primary"
        [disabled]="!canBid"
      >Place Bid</ds-button>
    </ds-box-footer>

  </ds-modal>
  <ds-modal
    #vehicleOverviewForCompletedModal
    [ds-modal-trigger-for]="vehicleOverviewForCompletedModal"
    [(isModalOpen)]="vehicleOverviewForCompletedModalIsOpen"
    [dimensionsConfig]="{ width: '400px', height: 'auto' }"
    [detachFooter]="true">
    <ds-box-header>
      Vehicle Overview
    </ds-box-header>
    <ds-box-content>
      <div class="vehicle-check-details">
        <div *ngFor="let item of [
          { label: 'Key Sets', value: initialVehicleCheckDetaisResponse.hasKeySets },
          { label: 'Tyre Thread', value: initialVehicleCheckDetaisResponse.hasTyreThread },
          { label: 'Full Service History', value: initialVehicleCheckDetaisResponse.hasFullServiceHistory },
          { label: 'Running Warranty', value: initialVehicleCheckDetaisResponse.hasRunningWarranty },
          { label: 'Motorplan', value: initialVehicleCheckDetaisResponse.hasMotorplan },
          { label: 'Registered in Customer\'s Name', value: initialVehicleCheckDetaisResponse.registeredInCustomersName },
          { label: 'Involved in Accident', value: initialVehicleCheckDetaisResponse.involvedInAccident },
          { label: 'CIA Comments', value: initialVehicleCheckDetaisResponse.ciaComments },
          { label: 'Photographs', value: 'yes' }
        ]" class="d-flex justify-content-between align-items-center mb-2">
          <span>{{ item.label }}</span>
          <span [ngClass]="item.label === 'Photographs' ? '' : (item.value ? 'text-success' : 'text-danger')">
            <ng-container *ngIf="item.label === 'Photographs'">
              <ds-icon
                *ngIf="item.value"
                icon="camera"
                size="lg"
                tone="action"
                title="Photographs available"
                (click)="openPhotographsForCompletedModal(BidModalCompletedVehicle)"
                style="cursor:pointer;"
              ></ds-icon>
              <span *ngIf="!item.value" style="color:red;">No Photographs</span>
            </ng-container>
            <ng-container *ngIf="item.label !== 'Photographs'">
              <span *ngIf="item.value" style="color:green;">Yes</span>
              <span *ngIf="!item.value" style="color:red;">No</span>
            </ng-container>
          </span>
        </div>
      </div>
    </ds-box-content>
    <ds-box-footer>
      <ds-button
        variant="outline"
        style="margin-right: 5px"
        (click)="closeOverviewModal()"
      >Close</ds-button>
<!--      <ds-button-->
<!--        ds-button-->
<!--        size="md"-->
<!--        (click)="openPlacebidModal(BidModalVehicle)"-->
<!--        title="open place bid modal"-->
<!--        variant="primary"-->
<!--      >Place Bid</ds-button>-->
    </ds-box-footer>

  </ds-modal>
  <ds-modal
    #highestBidDisclaimerModal
    [ds-modal-trigger-for]="highestBidDisclaimerModal"
    [(isModalOpen)]="highestBidDisclaimerModalOpen"
    [dimensionsConfig]="{ width: '400px', height: 'auto' }"
    [detachFooter]="true">
    <ds-box-header>
      Accept Highest Bid
    </ds-box-header>
    <ds-box-content>
      {{ highestBidDisclaimer }}
    </ds-box-content>
    <ds-box-footer>
      <ds-button
        variant="outline"
        style="margin-right: 5px"
        (click)="highestBidDisclaimerModalOpen=false"
      >Close
      </ds-button>
      <ds-button
        ds-button
        size="md"
        (click)="onAcceptHighestBidService(highestBidVehicle)"
        title="accept bid"
        variant="primary"
      >Accept Bid
      </ds-button>
    </ds-box-footer>

  </ds-modal>
  <ds-modal
    #vehicleOverviewForPurchasingModal
    [ds-modal-trigger-for]="vehicleOverviewForPurchasingModal"
    [(isModalOpen)]="vehicleOverviewForPurchasingModalIsOpen"
    [dimensionsConfig]="{ width: '400px', height: 'auto' }"
    [detachFooter]="true">
    <ds-box-header>
      Vehicle Overview
    </ds-box-header>
    <ds-box-content>
      <div class="vehicle-check-details">
        <div *ngFor="let item of [
          { label: 'Key Sets', value: initialVehicleCheckDetaisResponse.hasKeySets },
          { label: 'Tyre Thread', value: initialVehicleCheckDetaisResponse.hasTyreThread },
          { label: 'Full Service History', value: initialVehicleCheckDetaisResponse.hasFullServiceHistory },
          { label: 'Running Warranty', value: initialVehicleCheckDetaisResponse.hasRunningWarranty },
          { label: 'Motorplan', value: initialVehicleCheckDetaisResponse.hasMotorplan },
          { label: 'Registered in Customer\'s Name', value: initialVehicleCheckDetaisResponse.registeredInCustomersName },
          { label: 'Involved in Accident', value: initialVehicleCheckDetaisResponse.involvedInAccident },
          { label: 'CIA Comments', value: initialVehicleCheckDetaisResponse.ciaComments }
        ]" class="d-flex justify-content-between align-items-center mb-2">
          <span>{{ item.label }}</span>
          <span [ngClass]="item.value ? 'text-success' : 'text-danger'">
            <span *ngIf="item.value" style="color:green;">Yes</span>
            <span *ngIf="!item.value" style="color:red;">No</span>
          </span>
        </div>
        <div class="d-flex justify-content-between align-items-center mb-2">
          <span>Photographs</span>
          <span>
            <ng-container *ngIf="BidModalPurchasingVehicle.photographsList?.length || BidModalPurchasingVehicle.photographS3Keys; else noPurchasingPhotos">
              <ds-icon
                icon="camera"
                size="lg"
                tone="action"
                title="Photographs available"
                (click)="openPhotographsForPurchasingModal(BidModalPurchasingVehicle)"
                style="cursor:pointer;"
              ></ds-icon>
            </ng-container>
            <ng-template #noPurchasingPhotos>
              <span style="color:red;">No Photographs</span>
            </ng-template>
          </span>
        </div>
      </div>
    </ds-box-content>
    <ds-box-footer>
      <ds-button
        variant="outline"
        style="margin-right: 5px"
        (click)="closeOverviewModal()"
      >Close</ds-button>
    </ds-box-footer>
  </ds-modal>
</main>
